import PropTypes from 'prop-types';

const propTypes = {
  accessToken: PropTypes.string.isRequired,
  googleAppId: PropTypes.number,
  expiresAt: PropTypes.number,
};

class GoogleProfile {
  static propTypes = propTypes;
}

export default GoogleProfile;
